import { Directive, ElementRef, OnInit } from "@angular/core";
import moment from "moment";
import { SharedService } from "../pages/Services/shared.service";

@Directive({
    selector : '[NullDate]'
})
export class NullDate implements OnInit{
    constructor(private elementRef : ElementRef,
        private sharedService: SharedService,
        ){

    }
    ngOnInit(){
    }
    ngAfterViewChecked(){
        if(this.elementRef.nativeElement.value){
            let elementDate = moment(this.elementRef.nativeElement.value, this.sharedService.getDateFormat())
            let nullDate = moment("12/30/1899", "MM/DD/YYYY") // Need to nullify date : 30 Dec 1899
            let d1 = moment(elementDate).format("MM/DD/YYYY")
            let d2 = moment(nullDate).format("MM/DD/YYYY")
            if(d1 == d2){
                (this.elementRef.nativeElement.value = null)
            }
        }
    }

}